module.exports = __webpack_public_path__ + "static/sunburst-logo-yellow-white-4eb2436826e8fc7171d19f1049b25091.png";